<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-lg-6">

          <validated-form-select name="signer" :options="signers" label="4UL esindaja:"
                                 placeholder="- Vali 4UL esindaja -"
                                 v-model="contract.signer" validate="required" :validator="$validator"/>

          <validated-form-select name="manager" :options="managers" label="Kliendihaldur:"
                                 placeholder="- Vali kliendihaldur -"
                                 v-model="contract.manager" validate="required" :validator="$validator"/>
        </div>

        <div class="col-lg-6">
          <validated-form-select name="clientSigner" :options="clientSigners" label="Kliendi esindaja:"
                                 placeholder="- Vali kliendi esindaja -"
                                 v-model="contract.clientSigner" validate="required" :validator="$validator"/>

          <validated-form-input name="maxCreditDays" label="Krediidi pikkus (päevades):" placeholder="Krediidi pikkus"
                                v-model="contract.maxCreditDays"
                                validate="required|numeric" :validator="$validator"/>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <submit-button class="float-right" variant="primary">Laadi alla PDF</submit-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import ValidatedFormInput from '@/components/ValidatedFormInput'
  import ValidatedFormSelect from '@/components/ValidatedFormSelect'
  import {representativeTypes, utils} from '@/services/Configuration'
  import gateway from '@/services/gateway'

  export default {
    components: {ValidatedFormInput, ValidatedFormSelect},
    props: ['clientId'],
    data() {
      return {
        signers: [],
        managers: [],
        clientSigners: [],
        contract: {
          signer: null,
          manager: null,
          clientSigner: null,
          maxCreditDays: 10
        }
      }
    },
    created() {
      this.types = utils.asSelectOptions(representativeTypes)
      gateway.get('/clients/' + this.clientId).then(r => {
        let client = r.data
        this.clientSigners.splice(1, 0, ...this.clientSignerSelectOptions(client.representatives))
        this.contract.manager = (client.manager || {}).id;
      });
      gateway.get('/users').then(r => {
        this.signers.splice(1, 0, ...this.signerSelectOptions(r.data))
        this.managers.splice(1, 0, ...this.managerSelectOptions(r.data))

        if (this.signers.find(v => v.value === this.$store.state.user.id)) {
          this.contract.signer = this.$store.state.user.id
        }
      })
    },
    methods: {
      signerSelectOptions(users) {
        return users.filter(u => u.withSignatureRight).map(u => {
          return {value: u.id, text: u.fullName}
        })
      },
      managerSelectOptions(users) {
        return users.map(u => {
          return {value: u.id, text: u.fullName}
        })
      },
      clientSignerSelectOptions(representatives) {
        return representatives.filter(r => r.withSignatureRight).map(r => {
          return {value: r.id, text: r.firstName + ' ' + r.lastName}
        })
      },
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          let contractParams = `${this.contract.signer}/${this.contract.manager}/${this.contract.clientSigner}/${this.contract.maxCreditDays}`
          window.open(`/api/clients/${this.clientId}/contract-pdf/${contractParams}`)
          this.$emit('done')
        })
      },
    }
  }
</script>
